import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=163b1bf0&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=163b1bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b1bf0",
  null
  
)

export default component.exports